import React, { useEffect, useState } from 'react';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { RichiesteEsoneroPage } from './pages/RichiesteEsoneroPage';
import { DettaglioRichiestaPage } from './pages/DettaglioRichiestaPage';
type Page = 'list' | 'detail';
interface SelectedRequest {
  id: string;
  companyName: string;
  submissionDate: string;
}
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState<Page>('list');
  const [selectedRequest, setSelectedRequest] = useState<SelectedRequest | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  // Check for existing session on mount
  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);
  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentPage('list');
    setSelectedRequest(null);
    localStorage.removeItem('isAuthenticated');
  };
  const handleViewDetail = (requestId: string, companyName: string, submissionDate: string) => {
    setSelectedRequest({
      id: requestId,
      companyName,
      submissionDate
    });
    setCurrentPage('detail');
  };
  const handleBackToList = () => {
    setCurrentPage('list');
    setSelectedRequest(null);
  };
  // Show loading state while checking authentication
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-50" data-id="element-0">
        <div className="text-gray-600" data-id="element-1">Caricamento...</div>
      </div>;
  }
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} data-id="element-2" />;
  }
  return <AppLayout onLogout={handleLogout} data-id="element-3">
      {currentPage === 'list' && <RichiesteEsoneroPage onViewDetail={handleViewDetail} data-id="element-4" />}
      {currentPage === 'detail' && selectedRequest && <DettaglioRichiestaPage requestId={selectedRequest.id} companyName={selectedRequest.companyName} submissionDate={selectedRequest.submissionDate} onBack={handleBackToList} data-id="element-5" />}
    </AppLayout>;
}